import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
// import Transition from 'react-transition-group/Transition';
import PerformanceReportsArchive from './PerformanceReportsArchive';
import PerformanceReportsSingle from './PerformanceReportsSingle';

const PerformanceReports = props => (
  <BrowserRouter basename={`/${props.basename}`}>
    <Switch>
      <Route
        path="/:report_slug/:orgSlug?/:docSlug?"
        exact
        render={matchProps => <PerformanceReportsSingle {...props} {...matchProps} />}
      />
      <Route
        path="/"
        exact
        render={matchProps => <PerformanceReportsArchive {...props} {...matchProps} />}
      />
    </Switch>
  </BrowserRouter>
);

export default PerformanceReports;

PerformanceReports.propTypes = {
  basename: PropTypes.string.isRequired,
};
